import React from 'react'
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/sidebar/Sidebar'
import './home.scss'
import 'firebase/auth'
import { PieChart } from '@mui/x-charts/PieChart';
import Typography from '@mui/material/Typography';
import { UserAuth } from '../../context/AuthContext';
import { storage, DB } from '../../firebase';
import { getMetadata, ref, listAll, getDownloadURL, list } from "firebase/storage";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  orderBy
} from "firebase/firestore";
import formatBytes from '../../sizeFormat';



const Home = () => {
  const locale = 'en';
  const [today, setDate] = React.useState(new Date()); // Save the current date to be able to trigger an update
  const [total, setTotal] = React.useState(0);
  const [totalSize, setTotalSize] = React.useState(0);
  const [userData, setUserData] = React.useState({});
  const [folders, setFolders] = React.useState({
    "voicemails": {
      files: 0,
      size: 0
    },
    "documents": {
      files: 0,
      size: 0
    },
    "images": {
      files: 0,
      size: 0
    },
    "videos": {
      files: 0,
      size: 0
    },
    "audios": {
      files: 0,
      size: 0
    },
  })
  const [voicemailFiles, setVoicemailFiles] = React.useState(0);
  const [documentFiles, setDocumentFiles] = React.useState(0);
  const [videoFiles, setVideoFiles] = React.useState(0);
  const [imageFiles, setImageFiles] = React.useState(0);
  const [textFiles, setTextFiles] = React.useState(0);
  const [contactFiles, setContactFiles] = React.useState(0);
  const [audioFiles, setAudioFiles] = React.useState(0);

  const [voicemailSize, setVoicemailSize] = React.useState(0);
  const [videoSize, setVideoSize] = React.useState(0);
  const [audioSize, setAudioSize] = React.useState(0);
  const [contactsSize, setContactSize] = React.useState(0);
  const [textSize, setTextSize] = React.useState(0);
  const [documentSize, setDocumentSize] = React.useState(0);
  const [imageSize, setImageSize] = React.useState(0);

  const { user } = UserAuth();

  React.useEffect(() => {
    // const timer = setInterval(() => { // Creates an interval which will update the current data every minute
    //   // This will trigger a rerender every component that uses the useDate hook.
    //   setDate(new Date());
    // }, 60 * 1000);

    const listGraph = async () => {
      if (user) {
        await listingContacts();
        await listingSMS();
        const reference = await ref(storage, `${user.uid}`);
        const _listAll = await listAll(reference);
        await listing(_listAll.prefixes);
      }
    }

    const getUserData = async () => {
      if (user) {
        const docRef = doc(DB, "users", user.uid);
        const _data = await getDoc(docRef);
        const docRef2 = doc(DB, "subscriptionplans", _data.data().plan);
        const _data2 = await getDoc(docRef2);
        setUserData({ user: _data.data(), plan: _data2.data() });
      }
    }

    // return () => {
    //   clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    // }
    getUserData();
    listGraph();
  }, [user]);

  const calculateFolderSize = async (listRes) => {
    let res = 0;
    let m;
    for (let item of listRes.items) {
      m = await getMetadata(item);
      res = res + m.size;
    }
    return res;
  }

  const listing = async (prefixes) => {

    let total = 0;
    let totalSize = 0;
    // let result = {
    //   "voicemails": {
    //     files: 0,
    //     size: 0
    //   },
    //   "documents": {
    //     files: 0,
    //     size: 0
    //   },
    //   "images": {
    //     files: 0,
    //     size: 0
    //   },
    //   "videos": {
    //     files: 0,
    //     size: 0
    //   },
    //   "audios": {
    //     files: 0,
    //     size: 0
    //   },
    // }
    for (let prefix of prefixes) {
      let _ref = await ref(storage, `${user.uid}/${prefix.name}`)
      let _list = await list(_ref);
      let size = await calculateFolderSize(_list);
      total = total + _list.items.length;
      totalSize = totalSize + size;
      // result[prefix.name].files = _list.items.length
      // result[prefix.name].size = size
      //console.log(`${prefix.name}: ${size} - ${total}`)
      switch (prefix.name) {
        case "voicemails":
          setVoicemailFiles(_list.items.length);
          setVoicemailSize(size);
          break;
        case "documents":
          setDocumentFiles(_list.items.length);
          setDocumentSize(size);
          break;
        case "images":
          setImageFiles(_list.items.length);
          setImageSize(size);
          break;
        case "videos":
          setVideoFiles(_list.items.length);
          setVideoSize(size);
          break;
        case "audios":
          setAudioFiles(_list.items.length);
          setAudioSize(size);
          break;
        default:
          break;
      }
    }
    setTotal(total);
    setTotalSize(totalSize);
    //setFolders(result);
    return true;
  }

  const listingContacts = async () => {
    const docRef = doc(DB, "users", user.uid);
    const querySnapshot = await getDocs(collection(docRef, "Contacts"));
    setContactFiles(querySnapshot.docs.length);
    setContactSize(querySnapshot.docs.length * 4096);
    setTotal(total + querySnapshot.docs.length);
    setTotalSize(totalSize + (querySnapshot.docs.length * 4096));
    return true;
  }

  const listingSMS = async () => {
    const docRef = doc(DB, "users", user.uid);
    const querySnapshot = await getDocs(query(collection(docRef, "sms"), orderBy("address", "asc")));
    const rawData = [];
    querySnapshot.forEach((doc) => {
      rawData.push({
        from: doc.data().address
      })
    });
    const dataGrouped = Object.groupBy(rawData, ({ from }) => from);
    const length = Object.entries(dataGrouped).length
    setTextFiles(length);
    setTextSize(length * 4096);
    setTotal(total + length);
    setTotalSize (total + (length * 4096));
    return true;
  }

  //const day = today.toLocaleDateString(locale, { weekday: 'long' });
  //const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, { month: 'long' })}`;
  //const hour = today.getHours();
  //const wish = ` Good ${(hour < 12 && 'Morning') || (hour < 17 && 'Afternoon') || 'Evening'} `;
  //const time = today.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric' });
  return (
    <div className='home'>
      <Sidebar />
      <div className='homeContainer'>
        <Navbar />
        <div className='greetings' style={{ textAlign: 'left' }}>
          {/* {date},
          {'\n'}{time},
          {wish} */}
          <Typography>
            Welcome to your cloud access for all the files you have uploaded with the VoicemailSaver app on your phone. From here you can easily download selected or bulk files to your computer or any other device for permanent archival storage purposes. Once you have done that, you are at liberty to delete the file from this cloud site.
          </Typography>
        </div>
        <div className='totals' style={{paddingTop:50}}>
          Your current plan is: <b>{userData?.plan?.name}</b>
        </div>

        <div className="container" style={{justifyContent:'space-around'}}>
          <div style={{alignItems:'center'}}>
            <span>Folder distribution</span>
            <PieChart
              series={[
                {
                  data: [
                    // { id: 0, value: folders.voicemails.files, label: 'Voicemails' },
                    // { id: 1, value: folders.images.files, label: 'Photos' },
                    // { id: 2, value: folders.documents.files, label: 'Documents' },
                    // { id: 3, value: folders.videos.files, label: 'Videos' },
                    // { id: 4, value: folders.audios.files, label: 'Audios' },
                    { id: 0, value: voicemailFiles, label: 'Voicemails' },
                    { id: 1, value: imageFiles, label: 'Photos' },
                    { id: 2, value: documentFiles, label: 'Documents' },
                    { id: 3, value: videoFiles, label: 'Videos' },
                    { id: 4, value: audioFiles, label: 'Audios' },
                    { id: 5, value: textFiles, label: 'SMS' },
                    { id: 6, value: contactFiles, label: 'Contacts' }

                  ],
                  innerRadius: 30,
                  outerRadius: 100,
                  paddingAngle: 5,
                  cornerRadius: 5,
                  startAngle: -45,
                  endAngle: 225,
                  cx: 150,
                  cy: 150,
                  highlightScope: { fade: 'global', highlight: 'item' },

                },
              ]}
              width={400}
              height={300}
              slotProps={{
                legend: {
                  labelStyle: {
                    //fontSize: 12,
                    fill: 'gray',
                  },
                },
              }}
            />
            <span>
               Total files: {total}
            </span>
          </div>
          <div >
            <span>Storage</span>
            <PieChart
              series={[{
                innerRadius: 50,
                outerRadius: 100,
                data: [
                  { label: '% Used', value:  ((totalSize * 100) / userData?.plan?.limit).toFixed(2), color: '#0088FE' },
                  { label: '% Free', value: 100 - ((totalSize * 100) / userData?.plan?.limit).toFixed(2), color: '#00C49F' },
                ].filter(item => item.value && item.value > 0),
                arcLabel: 'value'
              }]}
              width={400}
              height={300}
            />
            <span>
              Total stored: {formatBytes(totalSize)} / {formatBytes(userData?.plan?.limit)}
            </span>
          </div>
        </div>
        <div className='totals'>

        </div>
        <div style={{ paddingLeft: 20, paddingRight: 20 }}>
          <Typography>NOTE, deleting files from this site does not automatically delete them from your phone. When you have confirmation that the files are safely stored on your device, you are then free to delete them from your phone, which will free up space on your phone. This applies to all files but particularly with voicemail messages, it will make more room for new messages so they will no longer appear full to callers</Typography>
        </div>
      </div>
    </div>

  );

};

export default Home;